import React, { useState, useEffect } from "react";
import { Container, InputField } from "@common";
import DataTableReact from "@common/datatable/DataTableReact.jsx";
import apiService from "services/apiService";
import { Dots } from "../../assets/svg.js";
import { Menu, MenuItem } from "@mui/material";
import CustomModal from "@common/CustomModal/CustomModal.js";
import { Button, Modal, ModalBody, ModalFooter } from "reactstrap";
import { FaPlus } from "react-icons/fa6";
import { toast } from "react-toastify";
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
function MedSpecialties() {
  const [medSpecialties, setMedSpecialties] = useState([]);
  const [editableSpecialtie, setEditableSpecialtie] = useState(null);
  const [openRowId, setOpenRowId] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteSpecialtieId, setDeleteSpecialtieId] = useState("");
  const [openForm, setOpenForm] = useState(false);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);

  const handleClick = (event, rowId) => {
    setAnchorEl(event.currentTarget);
    setOpenRowId(rowId);
  };
  const handleCloseTableModal = () => {
    setAnchorEl(null);
    setOpenRowId(null);
  };

  function handleDeleteSpecialtie(id) {
    apiService
      .post(`moh_manager/delete/medSpecialties`, {
        id: id,
      })
      .then((res) => {
        toast.success(res.message);
        fetchMedSpecialties();
        setIsModalOpen(false);
        setDeleteSpecialtieId("");
      })
      .catch((err) => {
        toast.error(err.response.data.message);
        console.log("Error Deleting medSpecialties", err);
      });
  }

  function handleCreateSpecialtie(values) {
    apiService
      .post("moh_manager/create/medSpecialties", {
        name: values.medSpecialtiesName,
        description: values.description,
      })
      .then((res) => {
        toast.success(res.message);
        fetchMedSpecialties();
      })
      .catch((err) => {
        toast.error(err.response.data.message);
        console.log("Error creating medSpecialties", err);
      });
  }

  function handleUpdateSpecialtie(values) {
    apiService
      .post(`moh_manager/update/medSpecialties`, {
        name: values.medSpecialtiesName,
        id: editableSpecialtie?.id,
        description: values.description,
      })
      .then((res) => {
        toast.success(res.message);

        fetchMedSpecialties();
        setEditableSpecialtie(null);
        setIsEdit(false);
      })
      .catch((err) => {
        toast.error(err.response.data.message);
        console.log("Error Updating medSpecialties", err);
      });
  }

  function handleSpecialtieSubmit(values, { resetForm }) {
    if (isEdit) {
      handleUpdateSpecialtie(values);
    } else {
      handleCreateSpecialtie(values);
    }
    setOpenForm(false);
    resetForm();
  }

  const columns = [
    {
      id: "Specialtie Name",
      header: "Specialtie Name",

      accessorFn: (row) => {
        return (
          <span className="line-clamp-1 self-stretch overflow-hidden text-[#0A0D14] text-ellipsis font-inter text-sm font-normal leading-[20px] tracking-[-0.084px]">
            {row?.medSpecialtiesName}
          </span>
        );
      },
    },
    {
      id: "Description",
      header: "Description",

      accessorFn: (row) => {
        return (
          <span className="line-clamp-1 self-stretch overflow-hidden text-[#0A0D14] text-ellipsis font-inter text-sm font-normal leading-[20px] tracking-[-0.084px]">
            {row?.description ? row?.description : ""}
          </span>
        );
      },
    },
  ];
  const renderRowActions = ({ row, table }) => {
    const isOpen = openRowId === row.index;

    return (
      <>
        <div className="flex gap-3">
          <Dots
            className="action-icon cursor-pointer"
            onClick={(e) => handleClick(e, row?.index)}
          />
        </div>

        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={isOpen}
          onClose={handleCloseTableModal}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
          sx={{
            boxShadow: "none", // Removing box shadow
          }}
        >
          <MenuItem
            sx={{
              fontSize: "18px",
              padding: "1px 24px",
              minWidth: "150px",
              borderRadius: "16px",
              "&:hover": {
                backgroundColor: "#FFF",
              },
            }}
          >
            <div
              className="flex justify-between w-[100%] "
              onClick={() => {
                setAnchorEl(null);
                setOpenRowId(false);
              }}
            >
              <p
                className="self-center m-1 "
                onClick={() => {
                  setIsEdit(true);
                  setOpenForm(true);
                  setEditableSpecialtie({
                    name: row?.original?.medSpecialtiesName,
                    description: row?.original?.description,
                    id: row?.original?.id,
                  });
                }}
              >
                Edit
              </p>
            </div>
          </MenuItem>
          <MenuItem
            sx={{
              fontSize: "18px",
              padding: "1px 24px",
              minWidth: "150px",
              borderRadius: "16px",
              "&:hover": {
                backgroundColor: "#FFF",
              },
            }}
          >
            <div
              className="flex justify-between w-[100%] "
              onClick={() => {
                setAnchorEl(null);
                setOpenRowId(false);
              }}
            >
              <p
                className="self-center m-1 "
                onClick={() => {
                  setIsModalOpen(true);
                  setDeleteSpecialtieId(row?.original?.id);
                }}
              >
                Delete
              </p>
            </div>
          </MenuItem>
        </Menu>
      </>
    );
  };

  const handleRenderRowActions = ({ row, table }) =>
    renderRowActions({ row, table });

  const fetchMedSpecialties = async () => {
    try {
      const { data } = await apiService.get(
        `moh_manager/all/medSpecialties?is_pagination=true&per_page=${rowsPerPage}&page=${page}`
      );

      setTotalRows(data?.total);

      setMedSpecialties(
        data?.data?.map(({ name, _id, description, ...rest }) => ({
          medSpecialtiesName: name,
          description: description,
          id: _id,
          ...rest,
        }))
      );
    } catch (e) {
      console.log("Error fetching medSpecialties:", e);
    }
  };

  useEffect(() => {
    fetchMedSpecialties(page, rowsPerPage);
  }, [page, rowsPerPage]);

  const initialValues = {
    medSpecialtiesName: editableSpecialtie?.name
      ? editableSpecialtie?.name
      : "",
    description: editableSpecialtie?.description
      ? editableSpecialtie?.description
      : "",
  };
  const validationSchema = Yup.object({
    medSpecialtiesName: Yup.string().required("Specialtie Name is required"),
    description: Yup.string().required("Description is required"),
  });
  return (
    <Container>
      <div className="flex gap-2 mb-4">
        <h1>Specialty</h1>
        <div
          className="flex items-center justify-center w-12 h-12 bg-gray-100 rounded-full transition-transform transform duration-200 
                  hover:shadow-lg hover:scale-105 active:scale-95 cursor-pointer"
          onClick={() => setOpenForm(true)}
        >
          <FaPlus className="text-green-500 text-3xl" />
        </div>
      </div>
      <CustomModal
        isOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        title={"Delete Medical Specialty"}
        bodyText={"Do you want to delete this medical specialty?"}
        buttonText={"Delete"}
        onClick={() => handleDeleteSpecialtie(deleteSpecialtieId)}
      />
      {openForm && <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
        <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6 relative">
        <Formik
          initialValues={initialValues}
          enableReinitialize={true}
          validationSchema={validationSchema}
          onSubmit={handleSpecialtieSubmit}
        >
          {({ values, errors, touched, setFieldValue, handleChange }) => (
            <ModalBody>
              <Form>
                <div className="">
                  <div>
                    <InputField
                      isRequiredClass="text-[#2D9F75]"
                      label="Specialtie Name"
                      name="medSpecialtiesName"
                      isRequired={true}
                      height="h-[40px]"
                      value={values.medSpecialtiesName}
                      onChange={(e) => handleChange(e)}
                    />
                    {touched.medSpecialtiesName &&
                      errors.medSpecialtiesName && (
                        <div className="text-red-500 text-sm mt-1">
                          {errors.medSpecialtiesName}
                        </div>
                      )}
                  </div>
                  <div>
                    <InputField
                      isRequiredClass="text-[#2D9F75]"
                      label="Description Name"
                      name="description"
                      isRequired={true}
                      height="h-[40px]"
                      value={values.description}
                      onChange={(e) => handleChange(e)}
                    />
                    {touched.description && errors.description && (
                      <div className="text-red-500 text-sm mt-1">
                        {errors.description}
                      </div>
                    )}
                  </div>
                    <div className="d-flex justify-content-end self-end gap-2 mt-4">
                      <Button color="success" type="submit">
                        {!isEdit ? "Submit" : "Update"}
                      </Button>
                        <Button
                          color="danger"
                          type="submit"
                          onClick={() => {
                            setIsEdit(false);
                            setOpenForm(false);
                            setEditableSpecialtie(null);
                          }}
                        >
                          Cancel
                        </Button>
                    </div>
                </div>
              </Form>
            </ModalBody>
          )}
        </Formik>
      </div>
      </div>}

      <DataTableReact
        data={medSpecialties}
        columns={columns}
        renderRowActions={handleRenderRowActions}
        setPage={setPage}
        page={page}
        setRowsPerPage={setRowsPerPage}
        rowsPerPage={rowsPerPage}
        totalRows={totalRows}
        shouldShowActions={true}
      />
    </Container>
  );
}

export default MedSpecialties;
